<script setup lang="ts">
import VolleyballPitchSvg from '@collector/shared-ui-domain/assets/volleyball/pitch.svg'
import { useEventSettings } from '@desktop/views/Relation/composables'
import AssignPlayerOnPitchOverlay from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/AssignPlayerOnPitchOverlay/AssignPlayerOnPitchOverlay.vue'
import Pitch from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/Pitch/Pitch.vue'

import ReceptionPlusNegativeOverlay from '../ReceptionPlusNegativeOverlay.vue'
import { useAssignPlayerOnPitch } from './useAssignPlayerOnPitch'

const { eventSettings } = useEventSettings()
const { overlayClass } = useAssignPlayerOnPitch()
</script>

<template>
  <Pitch
    class="w-1/2 px-2 py-2.5"
    pitchImageClass="max-h-[calc(100vh-38rem)] min-h-27 tall:@xs:min-h-[clamp(6.75rem,25vh,13rem)]"
    :pitchImageSrc="VolleyballPitchSvg"
    fieldClass="aspect-[2] w-full"
  >
    <template #overlays>
      <ReceptionPlusNegativeOverlay />
      <AssignPlayerOnPitchOverlay
        v-if="eventSettings.assignPlayerOnPitch"
        :class="overlayClass"
      />
    </template>
  </Pitch>
</template>
